class Collaborator {
    constructor(id, userId, email, userInfos, isInherited, joinedTime = null) {
        this.id = id;
        this.userId = userId;
        this.email = email;
        this.userInfos = userInfos;
        this.isInherited = isInherited;
        this.joinedTime = joinedTime;
    }
}

export { Collaborator };
